import React, { useState } from 'react'
import { DialogTitle, DialogContent, Dialog, Button, Box } from '@mui/material'
import { Button as DialogButton, Field } from '@/ui'
import styles from '../ContractCard.module.scss'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import CloseButton from '@/components/CloseButton/CloseButton'

export const EmployeeRevision = ({ title = 'el_cause', onClose, sendForImprovement, isOpen }) => {
	const { t } = useTranslation()

	const [note, setNote] = useState('')

	return (
		<Dialog classes={{ paper: styles.dialog }} onClose={onClose} open={isOpen}>
			<Box>{onClose ? <CloseButton onClose={onClose}></CloseButton> : null}</Box>
			<DialogTitle classes={{ root: styles.sign__title }}>{t(title)}</DialogTitle>
			<DialogContent sx={{ paddingBottom: '40px' }}>
				<div className={styles.dialog__buttons__wrapper}>
					<Field
						value={note}
						onChange={(e) => {
							setNote(e)
						}}
						wrapperClassName={styles.textarea__wrapper}
						placeholder={t('el_cause_short')}
						rows={8}
						fieldType="textarea"
					/>
					<div className={styles.reset__button__wrapper}>
						<DialogButton type="button" onClick={sendForImprovement.bind(null, note)} disabled={!note}>
							{t('send_to_rework')}
						</DialogButton>
					</div>
					<Button
						type="button"
						variant="text"
						classes={{ root: cn(styles.button, styles.reset__button, styles.reset__button) }}
						onClick={onClose}
					>
						{t('cancel')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
